import { render, staticRenderFns } from "./ComplexTable.vue?vue&type=template&id=cf5fb120"
import script from "./ComplexTable.vue?vue&type=script&lang=js"
export * from "./ComplexTable.vue?vue&type=script&lang=js"
import style0 from "./ComplexTable.vue?vue&type=style&index=0&id=cf5fb120&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports